import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=4604d7b1&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4604d7b1')) {
      api.createRecord('4604d7b1', component.options)
    } else {
      api.reload('4604d7b1', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=4604d7b1&", function () {
      api.rerender('4604d7b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/togglebutton/Button.vue"
export default component.exports